exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* Sidebar background color */\n/* Sidebar header and footer color */\n/* Sidebar title text colour */\n/* Sidebar menu item hover color */\n.texts-danger {\n  color: #F68C1F; }\n\n.texts-success {\n  color: #00A85F; }\n\n.text-stop {\n  color: #ED1C24; }\n\n.cm-languageselect button {\n  width: 126px;\n  text-align: left; }\n  .cm-languageselect button > span > span {\n    font-weight: normal;\n    font-size: 13px;\n    font-family: Rubik; }\n\n.cm-languageselect .flag {\n  height: 17px;\n  margin-right: 0.5rem;\n  vertical-align: middle;\n  line-height: 1.4;\n  margin-top: -2px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./node_modules/sass-loader/lib/loader.js!./src/style/containers/ui/select/language-select.scss
// module id = 1078
// module chunks = 49